import gql from 'graphql-tag';

export const QUERY_ALL_CATEGORIES_TAGS = gql`query QueryAllCategoriesTags{
  productTags(where: {hideEmpty: true}, first: 200) {
    nodes {
      name
    }
  }
  productCategories(where: {hideEmpty: true}, first: 200) {
    nodes {
      name
      uri
    }
  }
}
`;

export default QUERY_ALL_CATEGORIES_TAGS;